export const SEARCH_JOBS = 'jobSearch/SEARCH_JOBS'
